import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from "@/contexts/i18n";
import { Box } from "@gemini/core";
import { NoPhoneFilledIcon } from "@gemini/icons";
import { useIsTablet } from "@/hooks";
export const NoPhoneInfo = ({ testId }) => {
    const { t } = useI18n();
    const isTablet = useIsTablet();
    return (_jsx(Box, { testId: testId, display: "flex", flexDirection: "column", justifyContent: "center", borderColor: "color.border.light.default", borderStyle: isTablet ? "solid" : "none", borderRadius: "radius.8", borderWidth: "borderWidth.1", width: isTablet ? "100%" : "min-content", padding: isTablet ? "spacing.16" : "spacing.none", color: "color.content.light.default", marginTop: isTablet ? "spacing.12" : "spacing.none", typography: "typography.body.14.regular", children: _jsxs(Box, { display: "flex", justifyContent: "center", textAlign: {
                "breakpoint.base": "left",
                "breakpoint.sm": "center",
            }, alignItems: "center", gap: "spacing.8", children: [_jsx(NoPhoneFilledIcon, { size: "sizing.16", color: "color.content.disabled" }), t("contact.provider.no_phone_sentense")] }) }));
};
